var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35.5,
    fill: "#F8B326",
    fillOpacity: 0.03,
    stroke: "#F8B326",
    strokeDasharray: "2 2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 33C41.5913 33 43.1174 33.6321 44.2426 34.7574C45.3679 35.8826 46 37.4087 46 39V46H42V39C42 38.4696 41.7893 37.9609 41.4142 37.5858C41.0391 37.2107 40.5304 37 40 37C39.4696 37 38.9609 37.2107 38.5858 37.5858C38.2107 37.9609 38 38.4696 38 39V46H34V39C34 37.4087 34.6321 35.8826 35.7574 34.7574C36.8826 33.6321 38.4087 33 40 33Z",
    stroke: "#F8B326",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 34H26V46H30V34Z",
    stroke: "#F8B326",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 31C29.1046 31 30 30.1046 30 29C30 27.8954 29.1046 27 28 27C26.8954 27 26 27.8954 26 29C26 30.1046 26.8954 31 28 31Z",
    stroke: "#F8B326",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b4b3743443a587fc9b41181fa51cea1c.svg";
export { ForwardRef as ReactComponent };